import React, { FC } from "react";

import { useTranslation } from "react-i18next";
import { Button } from "@mui/material";

import { PlusIcon } from "@/assets/icons";
import { HiddenOnScope } from "@/components/atoms";
import { useNavigation } from "@/shared/hooks";

export const AddBrokerButton: FC = () => {
    const { t } = useTranslation();
    const { navToAddBroker } = useNavigation();

    return (
        <HiddenOnScope>
            <li style={{ textAlign: "center" }}>
                <Button
                    className="broker-add-button"
                    fullWidth
                    data-testid="my_broker_selector-button-add_broker"
                    onClick={navToAddBroker}
                    startIcon={<PlusIcon />}
                >
                    {t("MyBrokerSelector.AddBroker")}
                </Button>
            </li>
        </HiddenOnScope>
    );
};
